import { render } from "./VideoUploadInput.vue?vue&type=template&id=4429f615&scoped=true"
import script from "./VideoUploadInput.vue?vue&type=script&lang=js"
export * from "./VideoUploadInput.vue?vue&type=script&lang=js"

import "./VideoUploadInput.vue?vue&type=style&index=0&id=4429f615&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4429f615"]])

export default __exports__